import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const features = [
  {
    icon: 'ri-book-2-line',
    title: 'Reflexiones diarias',
    description: 'Meditaciones profundas inspiradas en la vida de María Magdalena',
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Oraciones guiadas',
    description: 'Encuentros íntimos con Dios a través de la oración contemplativa',
  },
  {
    icon: 'ri-quill-pen-line',
    title: 'Ejercicios de escritura',
    description: 'Expresión personal de tu camino espiritual',
  },
  {
    icon: 'ri-footprint-line',
    title: 'Acciones de fe',
    description: 'Pasos concretos para vivir tu transformación',
  },
  {
    icon: 'ri-whatsapp-line',
    title: 'Acompañamiento por WhatsApp',
    description: 'Comunidad y guía diaria en tu peregrinación',
  },
  {
    icon: 'ri-video-chat-line',
    title: 'Encuentros semanales por Zoom',
    description: 'Conexión en vivo con la comunidad',
  },
  {
    icon: 'ri-fire-line',
    title: '4 Masterclasses en vivo por Zoom',
    description: 'Cuatro encuentros formativos y espirituales con invitados especiales',
  },
  {
    icon: 'ri-sparkling-2-line',
    title: 'Semana Santa especial',
    description: '7 días, 7 liberaciones interiores',
  },
];

export default function Includes() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section ref={ref} className="relative py-32 px-6 bg-dark-900">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <h2 className="font-serif text-5xl md:text-6xl text-gold-400 mb-6">
            ¿Qué Incluye?
          </h2>
          <p className="font-sans text-xl text-warm-200 max-w-2xl mx-auto">
            Una experiencia completa de transformación espiritual
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group relative bg-dark-800 border border-gold-500/20 rounded-lg p-8 hover:border-gold-500/50 transition-all duration-300"
            >
              <div className="flex items-center justify-center w-16 h-16 bg-gold-500/10 rounded-full mb-6 group-hover:bg-gold-500/20 transition-all duration-300">
                <i className={`${feature.icon} text-4xl text-gold-400`}></i>
              </div>
              
              <h3 className="font-serif text-2xl text-warm-100 mb-3">
                {feature.title}
              </h3>
              
              <p className="font-sans text-warm-200 leading-relaxed">
                {feature.description}
              </p>

              {/* Decorative corner */}
              <div className="absolute top-0 right-0 w-12 h-12 border-t border-r border-gold-500/30 rounded-tr-lg"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}